import { relationShipMap } from '@/constants';
import { EAddMemberRelationship, IMutationQuery, TGender } from '../types';
import { gatewayAxiosInstance } from '../utils/axios';
import { decodeAuthToken } from '../utils/tokenUtils';

export const addFamilyMembersQuery = () => {
  return {
    queryKey: ['addFamilyMembers'],
    queryFn: async () => {
      const { memberId } = decodeAuthToken() ?? {};
      const url = `core/members/${memberId}/dependentEndorsementConfig`;

      //return sleep(1000, MOCK_DATA);
      const response = (await gatewayAxiosInstance.get(url)).data;

      const familyMembersData = response?.filter(
        (item: any) => item.benefitType === 'gmc'
      );
      return familyMembersData[0] ? familyMembersData[0] : [];
    },
  };
};

export const memberWithDependentsQuery = () => {
  return {
    queryKey: ['memberWithDependents'],
    queryFn: async () => {
      const { memberId, organisationId } = decodeAuthToken() ?? {};
      const url = `core/organisation/${organisationId}/member/${memberId}/memberWithDependents?includeEndorsementStatus=true&endorsementOperation=ADDITION&includeOnlyDependentAddedByMember=true`;

      //return sleep(1000, MOCK_DATA_REQUEST_HISTORY);

      return (await gatewayAxiosInstance.get(url)).data;
    },
  };
};

export const submitDependentQuery = (): IMutationQuery<any> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    mutationKey: [organisationId, memberId],
    mutationFn: async (relationData: any) => {
      // Accept payload as an argument
      const memberRelationship =
        relationShipMap[
          `${relationData.relationship}_${relationData.gender}` as `${EAddMemberRelationship}_${TGender}`
        ];
      const payload = {
        memberId: memberId,
        dependentDetails: [
          {
            firstName: relationData.firstName.charAt(0).toUpperCase() + relationData.firstName.slice(1),
            lastName: relationData.lastName.charAt(0).toUpperCase() + relationData.lastName.slice(1),
            relationship: memberRelationship, // Ensure this is the correct enum type
            gender: relationData.gender,
            dob: {
              date: new Date(relationData.dateOfBirth).getDate(),
              monthNumber: new Date(relationData.dateOfBirth).getMonth() + 1, // Months are zero-based
              year: new Date(relationData.dateOfBirth).getFullYear(),
              month: new Date(relationData.dateOfBirth).toLocaleString(
                'default',
                { month: 'long' }
              ),
            },
            dateOfMarriage: relationData.dateOfMarriage
              ? {
                  date: new Date(relationData.dateOfMarriage).getDate(),
                  monthNumber:
                    new Date(relationData.dateOfMarriage).getMonth() + 1, // Months are zero-based
                  year: new Date(relationData.dateOfMarriage).getFullYear(),
                  month: new Date(relationData.dateOfBirth).toLocaleString(
                    'default',
                    { month: 'long' }
                  ),
                }
              : undefined, // Optional field
          },
        ],
      };
      const url = `/core/organisation/${organisationId}/dependentEndorsementInActiveProgram`;
      // Make the POST request with the payload
      return await gatewayAxiosInstance.post(url, payload);
    },
  };
};
